define( function() {
	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/arr.js
// module id = 805
// module chunks = 2